import React, { useEffect, useState, useCallback, useRef } from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import { Col, Row, Table, Container, Card, InputGroup, FormControl, Modal, Button, Dropdown } from "react-bootstrap";
import Checkbox from "../components/Checkbox";
import HeaderCheckbox from "../components/HeaderCheckbox";
import { GrNext, GrPrevious } from "react-icons/gr";
import { useDropzone } from "react-dropzone";
import "./Upload.css";
import prettyBytes from "pretty-bytes";
import { DOCUMENT_TYPES } from "../constants/documentTypes.js";
import { uploadFileEmitter } from "../components/UploadFileEmitter";
import useFetchData from "../components/useFetchData";
import { useNavigate } from "react-router-dom";
//import { ReactComponent as ErrorUpload } from "bootstrap-icons/icons/x-circle.svg";
import ErrorUpload from "bootstrap-icons/icons/x-circle.svg?react";
import { useOutletContext } from "react-router-dom";

function IconSearch(props) {
   return (
      <svg viewBox="0 0 1024 1024" fill="currentColor" height="1em" width="1em" {...props}>
         <path d="M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" />
      </svg>
   );
}

export default function Upload() {
   const { openFileDialog } = useOutletContext();
   const navigate = useNavigate();
   const { fetchData } = useFetchData();
   const [isChecked, setIsChecked] = useState(false);
   const [fileCount, setFileCount] = useState(0);
   const [totalBytes, setTotalBytes] = useState(0);
   const [currentPage, setCurrentPage] = useState(1);
   const [totalPages, setTotalPages] = useState(1);
   const [searchTerm, setSearchTerm] = useState("");

   const [showDocumentDropdown, setShowDocumentDropdown] = useState(false);

   const [isUploadEnabled, setIsUploadEnabled] = useState(false);

   const handleDocumentToggle = () => {
      setShowDocumentDropdown(!showDocumentDropdown);
   };

   const [isHeaderCheckboxChecked, setIsHeaderCheckboxChecked] = useState(false);

   const itemsPerPage = 10;
   const [files, setFiles] = useState([]);
   const filteredFiles = files.filter((file) => file.name.toLowerCase().includes(searchTerm.toLowerCase()));
   const currentFiles = filteredFiles.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

   const MAX_IMAGE_SIZE = 5 * 1024 * 1024; // 5 MB in bytes
   const MAX_PDF_SIZE = 400 * 1024 * 1024; // 400 MB in bytes

   useEffect(() => {
      document.body.classList.add("app-task");
      return () => {
         document.body.classList.remove("app-task");
      };
   }, []);
   useEffect(() => {
      setFileCount(files.length); // Update file count whenever files state changes
      setTotalBytes(files.reduce((sum, file) => sum + file.size, 0)); // Update total bytes whenever files state changes

      const calculatedTotalPages = Math.ceil(filteredFiles.length / itemsPerPage);
      setTotalPages(calculatedTotalPages > 0 ? calculatedTotalPages : 1);
   }, [files]);
   useEffect(() => {
      const checkedFilesOnPage = filteredFiles.filter((file) => file.isChecked && file.index >= (currentPage - 1) * itemsPerPage && file.index < currentPage * itemsPerPage);
      setIsHeaderCheckboxChecked(checkedFilesOnPage.length > 0);
   }, [filteredFiles, currentPage]);

   // const handleDrop = useCallback(
   //    (acceptedFiles) => {
   //       setFiles((prevFiles) => {
   //          const newFiles = acceptedFiles.map((file, index) => ({
   //             index: files.length + index,
   //             isChecked: false,
   //             name: file.name,
   //             type: file.type,
   //             size: file.size,
   //          }));
   //          const updatedFiles = [...prevFiles, ...newFiles].map((file, index) => ({
   //             ...file,
   //             index,
   //          }));
   //          return updatedFiles;
   //       });
   //    },
   //    [setFiles]
   // );

   useEffect(() => {
      const handleFilesDropped = (acceptedFiles) => {
         setFiles((prevFiles) => {
            const updatedFiles = prevFiles.map((file) => ({
               ...file,
               isChecked: false,
            }));
            return updatedFiles;
         });

         setFiles((prevFiles) => {
            const newFiles = acceptedFiles.map((file, index) => ({
               index: prevFiles.length + index,
               isChecked: false,
               name: file.name,
               type: file.type,
               size: file.size,
               fileObject: file,
               docType: "",
               uploadStatus: 0, // 1 success, -1 error, -2 cancelled
            }));
            // const updatedFiles = [...prevFiles, ...newFiles].map((file, index) => ({
            //    ...file,
            //    index,
            // }));
            // return updatedFiles;
            return [...prevFiles, ...newFiles];
         });

         setIsHeaderCheckboxChecked(false);
      };

      // Listen for the 'filesDropped' event
      uploadFileEmitter.on("filesDropped", handleFilesDropped);

      // Clean up the listener on component unmount
      return () => {
         uploadFileEmitter.off("filesDropped", handleFilesDropped);
      };
   }, []);

   const handleFilesDropped = (acceptedFiles) => {
      setFiles((prevFiles) => {
         const updatedFiles = prevFiles.map((file) => ({
            ...file,
            isChecked: false,
         }));

         const newFiles = acceptedFiles.map((file, index) => {
            let hasError = false;

            if (file.type === "application/pdf" && file.size > MAX_PDF_SIZE) {
               hasError = true;
            } else if (file.type !== "application/pdf" && file.size > MAX_IMAGE_SIZE) {
               hasError = true;
            }

            return {
               index: prevFiles.length + index,
               isChecked: false,
               name: file.name,
               type: file.type,
               size: file.size,
               docType: "",
               uploadStatus: 0,
               fileObject: file,
               error: hasError,
               errorMsg: hasError ? "File size exceeded" : "",
            };
         });

         return [...prevFiles, ...newFiles];
      });

      setIsHeaderCheckboxChecked(false);
   };

   const onDrop = useCallback((acceptedFiles) => {
      handleFilesDropped(acceptedFiles);
   }, [handleFilesDropped]);

   const handlePageChange = (pageNumber) => {
      // Uncheck files on the current page before proceeding
      // setFiles((prevFiles) =>
      //    prevFiles.map((file) =>
      //       file.index >= (currentPage - 1) * itemsPerPage && file.index < currentPage * itemsPerPage ? { ...file, isChecked: false } : file
      //    )
      // );

      //console.log("HANDLEPAGECHANGE", pageNumber);
      setCurrentPage(pageNumber);
   };

   const Documenttype = () => {
      return (
         <Dropdown show={showDocumentDropdown} onToggle={handleDocumentToggle}>
            <Dropdown.Toggle disabled={!isHeaderCheckboxChecked} className="pt-1 pb-1 me-3" variant="outline-secondary" id="document-dropdown">
               Document Type
            </Dropdown.Toggle>
            <Dropdown.Menu>
               {/* Only "Invoice Statements" is offered for now. Other document
                   types are hidden until their pipelines are ready — restore the
                   commented items below to re-enable them. */}
               {/* <Dropdown.Item onClick={() => handleDocumentType("Invoices")}>Invoices</Dropdown.Item> */}
               <Dropdown.Item onClick={() => handleDocumentType("Invoice Statements")}>Invoice Statements</Dropdown.Item>
               {/* <Dropdown.Item onClick={() => handleDocumentType("Credit Slips")}>Credit Slips</Dropdown.Item> */}
               {/* <Dropdown.Item onClick={() => handleDocumentType("Bank Statements")}>Bank Statements</Dropdown.Item> */}
               {/* <Dropdown.Item onClick={() => handleDocumentType("Credit Card Statements")}>Credit Card Statements</Dropdown.Item> */}
            </Dropdown.Menu>
         </Dropdown>
      );
   };

   const handleRemoveCheckedFiles = () => {
      const remainingFiles = files.filter((file) => !file.isChecked);

      // Reindex the remaining files
      const reindexedFiles = remainingFiles.map((file, index) => ({
         ...file,
         index,
      }));

      setFiles(reindexedFiles);

      // Reset page if current page exceeds total pages after removal
      const newTotalPages = Math.max(1, Math.ceil(reindexedFiles.length / itemsPerPage));
      if (currentPage > newTotalPages) {
         //console.log("HANDLEREMOVECHECKEDFILES", currentPage);
         setCurrentPage(newTotalPages);
      }
      // if (currentPage > Math.ceil(remainingFiles.length / itemsPerPage)) {
      //    console.log("HANDLEREMOVECHECKEDFILES", currentPage);
      //    setCurrentPage(Math.max(1, Math.ceil(remainingFiles.length / itemsPerPage)));
      // }
   };

   const handleClearDocumentCheckedFiles = () => {
      setFiles((prevFiles) =>
         prevFiles.map((file) => {
            if (file.isChecked) {
               return { ...file, docType: "", isChecked: false };
            }
            return file;
         })
      );
      setIsHeaderCheckboxChecked(false);
   };

   const { getInputProps, getRootProps, open } = useDropzone({
      onDrop,
      accept: {
         "image/jpeg": [".jpeg", ".jpg"],
         "image/tiff": [".tiff", ".tif"],
         "image/png": [".png"],
         "application/pdf": [".pdf"],
      },
      maxFiles: 500,
      multiple: true,
      noClick: true,
      noKeyboard: true,
   });

   const handleDocumentType = (documentType) => {
      // We added a check to determine of the upload button can be enabled
      // setFiles((prevFiles) =>
      //    prevFiles.map((file) => {
      //       if (file.isChecked) {
      //          return { ...file, docType: documentType, isChecked: false };
      //       }
      //       return file;
      //    })
      // );

      // setIsHeaderCheckboxChecked(false);

      setFiles((prevFiles) => {
         const updatedFiles = prevFiles.map((file) => {
            if (file.isChecked) {
               return { ...file, docType: documentType, isChecked: false };
            }
            return file;
         });

         // Check if all files now have a document type assigned. Returns true all files have a doc type
         //const allFilesHaveDocType = updatedFiles.every((file) => file.docType);

         const allFilesHaveDocType = updatedFiles.filter((file) => !file.error).every((file) => file.docType);

         // Update the upload button's enabled/disabled state
         setIsUploadEnabled(allFilesHaveDocType);

         return updatedFiles;
      });

      setIsHeaderCheckboxChecked(false);
   };

   // Function to determine the state of the header checkbox
   const isHeaderCheckboxIndeterminate = () => {
      // Filter files based on the current page

      // this code did it by page
      // const filteredFiles = files.filter(
      //    (file) =>
      //       file.name.toLowerCase().includes(searchTerm.toLowerCase()) &&
      //       file.index >= (currentPage - 1) * itemsPerPage &&
      //       file.index < currentPage * itemsPerPage
      // );

      // const allChecked = filteredFiles.every(
      //    (file) => file.isChecked || file.index < (currentPage - 1) * itemsPerPage || file.index >= currentPage * itemsPerPage
      // );
      // const noneChecked = filteredFiles.every(
      //    (file) => !file.isChecked || file.index < (currentPage - 1) * itemsPerPage || file.index >= currentPage * itemsPerPage
      // );

      // Filter files based on the search term only
      const filteredFiles = files.filter((file) => file.name.toLowerCase().includes(searchTerm.toLowerCase()));

      // Check if all filtered files are checked
      const allChecked = filteredFiles.filter((file) => !file.error).every((file) => file.isChecked);

      // Check if none of the filtered files are checked
      const noneChecked = filteredFiles.filter((file) => !file.error).every((file) => !file.isChecked);

      // Update isAnyCheckboxChecked based on noneChecked
      //setIsAnyCheckboxChecked(!noneChecked);
      return !allChecked && !noneChecked;
   };

   const handleFileCheckboxChange = (index) => {
      const updatedFiles = files.map((file) => {
         if (file.index === index) {
            return { ...file, isChecked: !file.isChecked };
         }
         return file;
      });

      setFiles(updatedFiles);
   };

   const handleSelectAllCheckboxChange = (event) => {
      const checked = event.target.checked;

      // We use to select files displayed
      //Dimitro recommends to select all files

      // Determine which files are on the current page
      //const startIndex = (currentPage - 1) * itemsPerPage;
      //const endIndex = currentPage * itemsPerPage;

      // Filter files that are currently displayed on the current page
      //const displayedFiles = filteredFiles.slice(startIndex, endIndex);

      // Update the isChecked status of the displayed files
      //const updatedFiles = files.map((file) => {
      //   if (displayedFiles.some((displayedFile) => displayedFile.name === file.name)) {
      //      return { ...file, isChecked: checked };
      //   }
      //   return file;
      //});

      // Update the isChecked status of all files in the array
      const updatedFiles = files.map((file) => ({
         ...file,
         isChecked: file.error ? false : checked,
      }));
      console.log("UPDATEDFILES:", updatedFiles);
      setFiles(updatedFiles);

      setIsChecked(checked);
   };

   const Pagination = ({ totalPages, currentPage, onPageChange }) => {
      //console.log("CURRENTPAGE:", currentPage);
      const pageNumbers = [];
      const maxPagesToShow = 7;

      for (let i = 1; i <= totalPages; i++) {
         pageNumbers.push(i);
      }

      const startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
      const endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

      const renderPageNumbers = () => {
         const pages = [];

         pages.push(
            <li key="prev" className="pagination-item">
               <button onClick={() => onPageChange(currentPage - 1)} className="page-link">
                  <GrPrevious size={20} />
               </button>
            </li>
         );

         if (startPage > 2) {
            pages.push(
               <li key="ellipsis1" className="pagination-item disabled">
                  <span className="page-link">...</span>
               </li>
            );
         }
         for (let i = startPage; i <= endPage; i++) {
            pages.push(
               <li key={i} className={`pagination-item ${i === currentPage ? "active" : ""}`}>
                  <button onClick={() => onPageChange(i)} className="page-link">
                     {i}
                  </button>
               </li>
            );
         }
         if (endPage < totalPages - 1) {
            pages.push(
               <li key="ellipsis2" className="pagination-item disabled">
                  <span className="page-link">...</span>
               </li>
            );
         }

         pages.push(
            <li key="next" className="pagination-item">
               <button onClick={() => onPageChange(currentPage + 1)} className="page-link">
                  <GrNext size={20} />
               </button>
            </li>
         );

         return pages;
      };

      return <ul className="pagination">{renderPageNumbers()}</ul>;
   };

   const handleUpload = async () => {
      const filesWithoutErrors = files.filter((file) => !file.error);
      navigate("/apps/uploadupdate", { state: { files: filesWithoutErrors } });
   };

   return (
      <>
         <Header />
         <div className="main main-app p-3 p-lg-4 p-xxl-5}">
            <Container fluid>
               <Row className="justify-content-start">
                  <Col xs="auto">
                     <h2 className="main-title fs-2 mb-1">Upload</h2>
                     <h3 className="fs-5 mt-5 mb-1">Add the files you want to upload to Rekonsil. You are limited to 1000 pages per pdf and no more than 100MB per file.</h3>
                  </Col>
               </Row>
               <Row className="justify-content-start">
                  <Col xs="auto">
                     <Card {...getRootProps()}
  className="responsive-card mt-4 upload-card"
  role="button"
  tabIndex={0}
  onClick={openFileDialog}
  onKeyDown={(e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      openFileDialog();
    }
  }}
>
                        <Card.Body className="upload-card">
                           <Card.Text className="fs-6 text-center mb-0">Drag and drop files you want to upload here, or choose Add files.</Card.Text>
                        </Card.Body>
                     </Card>
                  </Col>
               </Row>
               <Row className="justify-content-start">
                  <Col xs="auto">
                     <Card className="responsive-card mt-4">
                        <Card.Body className="p-0 m-0">
                           <div style={{ backgroundColor: "var(--rk-surface)" }}>
                              <div className="d-flex justify-content-between align-items-start pt-3 ps-3 pe-3">
                                 <div className="h4">
                                    Files <span className="fw-medium fs-5">{fileCount > 0 && `(${fileCount} Total, ${prettyBytes(totalBytes)})`}</span>
                                 </div>
                                 <div className="d-flex align-items-center pe-3">
                                    <button type="button" className="btn btn-outline-secondary me-3 pb-1 pt-1 pe-3" disabled={!isHeaderCheckboxChecked} onClick={handleClearDocumentCheckedFiles}>
                                       Clear Document Type
                                    </button>
                                    <Documenttype />

                                    <button type="button" className="btn btn-outline-secondary me-3 pb-1 pt-1 pe-3" disabled={!isHeaderCheckboxChecked} onClick={handleRemoveCheckedFiles}>
                                       Remove
                                    </button>
                                    <button type="button" className="btn btn-outline-secondary  pb-1 pt-1 ps-3 pe-3" onClick={openFileDialog}>
                                       Add files
                                    </button>
                                 </div>
                              </div>
                              <div className="d-flex justify-content-start ps-3 pb-3">
                                 <div style={{ fontSize: "12px" }}>All files in this table will be uploaded. We support PNG, JPEG, TIFF and PDF file types.</div>
                              </div>
                              <div className="d-flex justify-content-between ps-3  pe-3 pb-3">
                                 <div>
                                    {/* <input {...getInputProps()} /> */}
                                    <InputGroup className="">
                                       <InputGroup.Text className="search-upload bg-white border-black border-right-0" id="basic-addon1">
                                          <IconSearch size={18} />
                                       </InputGroup.Text>
                                       <FormControl style={{ width: "300px" }} className="border-start-0 border-black ps-0" placeholder="Find by name" aria-label="Find by name" aria-describedby="basic-addon1" value={searchTerm} id="table-filter" onChange={(e) => setSearchTerm(e.target.value)} />
                                    </InputGroup>
                                 </div>
                                 <div id="pagination">
                                    <Pagination totalPages={totalPages} currentPage={currentPage} onPageChange={handlePageChange} />
                                 </div>
                              </div>
                           </div>
                           <Table className="upload-table mb-0 table-bordered">
                              <thead>
                                 <tr>
                                    <th className="headings" scope="col" style={{ width: "40px" }}>
                                       <HeaderCheckbox indeterminate={isHeaderCheckboxIndeterminate()} checked={isHeaderCheckboxChecked} onChange={handleSelectAllCheckboxChange} ariaLabel="Select file" />
                                    </th>
                                    <th className="headings" scope="col">
                                       Name
                                    </th>
                                    <th className="headings" scope="col">
                                       Document Type
                                    </th>
                                    <th className="headings" scope="col">
                                       File Type
                                    </th>
                                    <th className="headings" scope="col">
                                       Size
                                    </th>
                                    <th className="headings" scope="col">
                                       Upload Status
                                    </th>
                                 </tr>
                              </thead>
                              <tbody>
                                 {currentFiles.length > 0 ? (
                                    currentFiles.map((file) => (
                                       <tr key={file.index}>
                                          <td>
                                             <Checkbox disabled={file.error} checked={file.isChecked} onChange={() => handleFileCheckboxChange(file.index)} ariaLabel="" />
                                          </td>
                                          <td>{file.name}</td>
                                          <td>{file.docType}</td>
                                          <td>{file.type}</td>
                                          <td>{prettyBytes(file.size)} </td>
                                          <td>
                                             {file.error && (
                                                <div style={{ color: "red", display: "flex", alignItems: "center" }}>
                                                   <ErrorUpload style={{ marginRight: "3px", height: "1em", width: "1em" }} />
                                                   <span style={{ fontWeight: "500" }}>{file.errorMsg}</span>
                                                </div>
                                             )}
                                          </td>
                                       </tr>
                                    ))
                                 ) : (
                                    <tr>
                                       <td colSpan="4">
                                          <div>No files loaded</div>
                                       </td>
                                    </tr>
                                 )}
                              </tbody>
                           </Table>
                        </Card.Body>
                     </Card>
                  </Col>
               </Row>
               <Row className="justify-content-start">
                  <Col xs="auto">
                     <Card className="responsive-card mt-4 border-0">
                        <Card.Body className="p-0 m-0">
                           <div className="d-flex justify-content-end">
                              <button type="button" className="btn btn-primary" onClick={handleUpload} disabled={files.length === 0 || !isUploadEnabled}>
                                 Upload files
                              </button>
                           </div>
                        </Card.Body>
                     </Card>
                  </Col>
               </Row>
            </Container>

            <Footer />
         </div>
      </>
   );
}
